import React, { useState, useEffect } from "react";
import { Form, Input, Button, message, Space, Checkbox } from "antd";
import { Link } from "react-router-dom";
import axiosInstance from "../../axios/axiosInstance";
import { useLocation } from "react-router-dom";
import axios from "axios"; // 假设我们使用axios来发送邮件
import "./login.scss";
import Logon from "./logon";
const Login = () => {
  const [form] = Form.useForm();
  const [type, setType] = useState(1);
  const [sendButtonDisabled, setSendButtonDisabled] = useState(false);
  const [timer, setTimer] = useState(null);
  const [countdown, setCountdown] = useState(0);
  const [phoneCode, setPhoneCode] = useState(null);
  const [pCode, setpCode] = useState(null);
  const [error, setError] = useState(null);
  const [agreeToTerms, setAgreeToTerms] = useState(false);

  const handleFinish = (values) => {
    if (!agreeToTerms) {
      message.warning("请阅读并同意用户协议和隐私政策");
      return;
    }
    setType(2);
    // 表单提交逻辑，如登录验证等
    console.log("Received values of form: ", values);
    let param = {
      ...values,
    };
    axiosInstance
      .post(`/account/register`, param)
      .then((response) => {
        console.log(response);
        if (response.data.code == "10000") {
          // setpCode(response.data);
          // setError(null);
        } else {
          message.error(response.data.msg);
        }
      })
      .catch((error) => {
        // setpCode(null);
        // setError(error);
      });
  };
  const handleGetCode = async () => {
    // 验证手机号是否正确
    try {
      await form.validateFields(["phone"]);
      const phone = form.getFieldValue("phone"); // 获取手机号
      setSendButtonDisabled(true); // 禁用按钮开始倒计时
      setCountdown(60);
      // 这里怎么调用接口设置 pCode
      axiosInstance
        .get(`/account/sendVerifyCode?phone=${phone}`)
        .then((response) => {
          if (response.code == "10000") {
            setpCode(response.data);
            setError(null);
          } else {
            message.error("这是一条报错提示");
          }
        })
        .catch((error) => {
          setpCode(null);
          setError(error);
        });
      // 这里可以调用后端API发送验证码
      // 使用setInterval实现倒计时
      const interval = setInterval(() => {
        setCountdown((prevCountdown) => {
          if (prevCountdown > 0) {
            return prevCountdown - 1;
          } else {
            clearInterval(interval);
            setSendButtonDisabled(false); // 倒计时结束，启用按钮
            return 0;
          }
        });
      }, 1000);
    } catch (error) {
      console.error("手机号验证失败", error);
    }
  };
  useEffect(() => {
    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [timer]);

  const handleOpenLink = (link) => {
    window.open(link, "_blank");
  };
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 },
    },
  };
  const changeLogin = () => {
    setType((prevType) => (prevType === 1 ? 2 : 1));
  };
  const passwordRules: RegularExpression[] = [
    { required: true, message: "请输入密码" },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || typeof value !== "string") {
          return Promise.resolve();
        }
        if (value.length < 6 || value.length > 16) {
          return Promise.reject("密码长度应为6-16位");
        }
        if (/[\u4e00-\u9fa5]/.test(value)) {
          return Promise.reject("密码不能包含中文");
        }
        return Promise.resolve();
      },
    }),
  ];
  return (
    <div className="login_div">
      <div className="login-cont">
        <img src={require("./img/login.png")} alt="" />
        <div className="form">
          <span></span>
          <Form
            form={form}
            name="forgotPassword"
            onFinish={handleFinish}
            autoComplete="off"
            {...formItemLayout}
          >
            <h2>{type == 1 ? "找回密码" : "重设密码"}</h2>
            {type == 1 ? (
              <div>
                <Form.Item
                  name="phone"
                  label="手机号"
                  rules={[
                    { required: true, message: "请输入手机号" },
                    {
                      pattern: /^\d{11}$/,
                      message: "请输入11位数字的手机号",
                    },
                  ]}
                >
                  <Input placeholder="输入手机号" />
                </Form.Item>
                <Form.Item
                  name="phoneCode"
                  label="验证码"
                  rules={[{ required: true, message: "请输入验证码" }]}
                >
                  <Space size={30}>
                    <Input placeholder="请输入验证码" />
                    <Button
                      type="primary"
                      onClick={handleGetCode}
                      disabled={sendButtonDisabled}
                      className="yam"
                    >
                      {countdown === 0 ? "获取验证码" : `${countdown}s`}
                    </Button>
                  </Space>
                </Form.Item>
              </div>
            ) : (
              <div>
                <Form.Item name="password" label="密码" rules={passwordRules}>
                  <Input.Password placeholder="输入登录密码" />
                </Form.Item>
                <Form.Item
                  name="confirmPassword"
                  label="确认密码"
                  rules={[
                    { required: true, message: "请再次输入密码" },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject("两次输入的密码不一致!");
                      },
                    }),
                  ]}
                >
                  <Input.Password placeholder="再次输入登录密码" />
                </Form.Item>
              </div>
            )}

            <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
              <div className="agreement-section">
                <Checkbox
                  checked={agreeToTerms}
                  onChange={(e) => setAgreeToTerms(e.target.checked)}
                >
                  我已阅读并同意
                </Checkbox>
                <a
                  href="/agreements/terms.html"
                  target="_blank"
                  className="agreement-link"
                >
                  《用户协议》
                </a>
                和
                <a
                  href="/agreements/privacy.html"
                  target="_blank"
                  className="agreement-link"
                >
                  《隐私政策》
                </a>
              </div>
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
              <Button type="primary" htmlType="submit" className="submit-btn">
                {type == 1 ? "下一步" : "完成设置"}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Login;
